export default __webpack_public_path__ + "static/media/dots-horizontal-circle.75d374c6.svg";